<template>
  <NotMobile__WP_Alert />

  <template v-if="districts">
    <v-alert :color="`#e8e8e8`" rounded="xl" class="mb-5">
      <v-sheet color="transparent" class="d-flex justify-space-between align-center">
        <p>ПРОИЗВОДСТВЕННЫЕ УЧАСТКИ</p>
        <v-avatar :color="`#ffffff`">
          <v-icon :icon="['fas', 'layer-group']" />
        </v-avatar>
      </v-sheet>
    </v-alert>

    <v-row>
      <v-col v-for="district in districts" :key="district" cols="12" sm="6" md="4" lg="2" xl="2">
        <v-hover>
          <template v-slot:default="{ isHovering, props }">
            <v-card :elevation="isHovering ? 10 : 0"
                    class="mb-2 my-district-card" v-bind="props" density="compact" variant="flat"
                    block rounded="xl" height="200px"
                    v-on:click="select_district(district)"
                    :image="`https://media.scgrdn.pro/boss/app_zn/district/${district.guid}.png`"
            >
              <v-card-title>
                <v-sheet rounded="xl" class="font-weight-bold pa-2 text-center district-name" :color="`rgba(0,0,0,0.2)`">
                  {{ district.name.toUpperCase() }}
                </v-sheet>
              </v-card-title>
            </v-card>
          </template>
        </v-hover>
      </v-col>
    </v-row>
  </template>
</template>

<script>
import moment from "moment";
import { TokenGUIDStore } from "@/store/global/SessionStore";
import route_check from "@/libs/route_check";
import { District__Guid, DistrictsList } from "@/store/global/districts.dictionary";
import NotMobile__WP_Alert from "@/components/wp_planner/alerts/not_mobile.alert.vue";

export default {
  name: 'A_Planner_DS',
  components: {NotMobile__WP_Alert},
  async beforeMount() {
    route_check('/autoplanner/district').then(async res => {
      this.loading = true
      if (!res) {
        this.$router.push({ name: 'home' })
      }
    })
  },
  methods: {
    moment,
    select_district: function (district) {
      this.district = district
      this.$router.push({ name: 'a__planner__y', params: { guid: district.guid, year: moment().format('YYYY') } })
    }
  },
  computed: {
    session_token() {
      return TokenGUIDStore().get()
    },
    districts: {
      get() {
        return DistrictsList().get()
      },
      set(value) {
        DistrictsList().set(value)
      }
    },
    district: {
      set(value) {
        District__Guid().set(value)
      },
      get() {
        return District__Guid().get()
      }
    }
  }
}

</script>

<style scoped>
.my-district-card {
  scale: 1;
  transition: 0.3s;
}
.my-district-card:hover {
  scale: 1.05;
}

.district-name {
  position: absolute;
  background: #fff !important;
  top: 0;
  left: 0;
  margin: 10px;
  width: calc(100% - 20px);
  scale: 1;
  backdrop-filter: blur(20px);
  color: #000000 !important;
  box-shadow: inset 0 0 10px rgba(38, 38, 38, 0.4);
  transition: 0.3s;
}

.my-district-card:hover .district-name {
  box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.5);
  scale: 0.95;
}
</style>
